import { cva } from "class-variance-authority";

export { default as Dialog } from "./Dialog.vue";
export { default as FeatureIcon } from "./FeatureIcon.vue";
export { default as ResponsiveDialog } from "./ResponsiveDialog.vue";
export { default as ResponsiveDialogClose } from "./ResponsiveDialogClose.vue";

export const contentVariants = cva(
    "flex flex-col [&>div]:pt-4 [&>div]:px-4 md:[&>div]:px-6 [&>div:last-of-type]:pb-4 [&>div]:border-secondary overflow-y-hidden",
    {
        variants: {
            variant: {
                default: "",
                small: "max-w-[25rem] [&>div]:pt-6 [&>div]:px-6 [&>div:last-of-type]:pb-6",
                "save-view":
                    "max-w-[25rem] [&>div]:pt-6 [&>div]:px-6 md:[&>div]:px-4 md:[&>div:first-of-type]:px-6 [&>div:last-of-type]:pt-4 [&>div:last-of-type]:pb-6",
                upload: "md:max-h-[67vh] [&>div:first-of-type]:pt-6 [&>div]:border-t [&>div]:bg-white [&>div:first-of-type]:bg-secondary [&>div:first-of-type]:pb-4 [&>div:first-of-type]:border-t-0",
                views: "max-w-[25rem] md:max-h-[67vh] md:[&>div]:px-4 [&>div:first-of-type]:p-6 [&>div:first-of-type]:pb-5 [&>div]:pb-4 [&>div]:border-b [&>div:last-of-type]:p-6 [&>div:last-of-type]:border-b-0",
                slideshow:
                    "max-w-[452px] [&>div:first-of-type]:pt-6 [&>div:last-of-type]:py-6",
                "task-creation":
                    "max-w-[700px] h-[31.25rem] [&>div]:pt-0 [&>div:first-of-type]:pt-6 [&_#footer]:pt-4 [&>div]:px-5 [&>div:first-of-type]:pb-4 [&>div:first-of-type]:bg-secondary [&>div]:border-b [&>div:last-of-type]:border-b-0",
                "task-action":
                    "max-w-[31.25rem] h-[31.25rem] [&>div]:pt-0 [&>div:first-of-type]:pt-6 [&>div:last-of-type]:pt-4 [&>div:first-of-type]:pb-4 [&>div:first-of-type]:bg-secondary [&>div]:border-b [&>div:last-of-type]:border-b-0",
                "action-log":
                    "max-w-[37.5rem] [&>div:first-of-type]:pt-6 [&>div]:pb-4 [&>div:first-of-type]:pb-5 [&>div:first-of-type]:bg-secondary [&>div:first-of-type]:border-b",
                upgrade: "max-w-[30rem] [&>div:first-of-type]:!p-0",
                share: "max-w-[37.5rem] [&>div:first-of-type]:pt-6 [&>div]:pt-5 [&>div]:px-6 [&>div:last-of-type]:pb-6",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
);

export const titleVariants = cva("", {
    variants: {
        variant: {
            default: "text-xl/normal font-semibold text-primary",
            "task-creation": "text-primary text-sm font-semibold",
            slideshow: "leading-normal",
            small: "leading-normal",
        },
    },
    defaultVariants: {
        variant: "default",
    },
});

export const descriptionVariants = cva("text-base font-medium text-tertiary", {
    variants: {
        variant: {
            default: "",
            slideshow: "text-sm",
            small: "text-sm leading-5",
        },
    },
    defaultVariants: {
        variant: "default",
    },
});

export const closeVariants = cva(
    "w-11 h-11 absolute ltr:right-2 rtl:left-2 top-2 ltr:md:right-4 rtl:md:left-4 md:top-3 flex items-center justify-center rounded-md opacity-70 ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground",
    {
        variants: {
            variant: {
                default: "",
                "task-creation": "!md:top-2",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
);
